import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TarefasService } from 'src/app/tarefas/service/tarefas.service';
import Swal from 'sweetalert2';
import { CommonLoaderComponent } from '../../common-loader/common-loader.component';

@Component({
  selector: 'app-criar-tarefa',
  standalone: true,
  imports: [CommonModule, FormsModule, CommonLoaderComponent],
  templateUrl: './criar-tarefa.component.html',
  styleUrls: ['./criar-tarefa.component.scss'],
})
export class CriarTarefaComponent implements OnInit {
  @Input() contatoInfo?: {
    id?: number;
    nome?: string;
    cargo?: string;
    email?: string;
  };

  @Input() obrasPredefinidas?: { workID: number; workName: string }[];
  
  @Output() fechar = new EventEmitter<void>();
  @Output() loading = new EventEmitter<boolean>();
  @Output() tarefaCriada = new EventEmitter<any>();

  userId: string;
  description = '';
  data = '';
  hora = '';
  responsibleID = '';
  actionID = '';
  responsavel: any[] = [];
  tarefas: any[] = [];
  obras: { workID: number; workName: string }[] = [];

  tarefaCriadaSucesso: boolean = false;
  campoObrigatorioErro: boolean = false;
  carregandoTarefas: boolean = false;

  today: string = new Date().toISOString().split('T')[0];
  selectedObra: '' | null = null;

  constructor(private readonly _tarefaService: TarefasService) {
    this.userId = localStorage.getItem('userId');
  }

  ngOnInit(): void {
    this.popularResponsavelObra();
    this.popularAcao();

    if (this.obrasPredefinidas) {
      this.obras = this.obrasPredefinidas;
    } else {
      this.listarObras();
    }
  }

  criarTarefa() {
    this.campoObrigatorioErro = false;
    if (!this.responsibleID || !this.actionID) {
      this.campoObrigatorioErro = true;
      console.error('Erro: Campos obrigatórios não preenchidos');
      return;
    }

    if (!this.selectedObra) {
      console.error('Erro: ID da obra não definido');
      this.campoObrigatorioErro = true;
      this.loading.emit(false);
      return;
    }

    const body = {
      ActionID: Number(this.actionID),
      FollowUp: this.formatFollowUp(this.data, this.hora),
      ResponsibleID: Number(this.responsibleID),
      Description: this.description,
      workID: this.selectedObra,
      isEdited: false,
      contactID: this.contatoInfo?.id ?? null,
    };
    this.carregandoTarefas = true;

    this._tarefaService.createTask(this.selectedObra, body).subscribe({
      next: (res) => {
        this.loading.emit(false);
        this.tarefaCriada.emit(res);
        this.tarefaCriadaSucesso = true;

        Swal.fire({
          title: 'Sucesso!',
          text: 'Tarefa criada com sucesso!',
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          this.fecharSucesso();
          this.carregandoTarefas = false;
          this.loading.emit(false);
        });
      },
      error: (err) => {
        this.carregandoTarefas = false;
        console.error('Erro ao criar tarefa:', err);
      },
    });
  }

  fecharSucesso() {
    this.tarefaCriadaSucesso = false;
    this.fechar.emit();
  }

  fecharModal() {
    this.tarefaCriada.emit();
  }

  formatFollowUp(date: string, time: string): string {
    if (!date || !time) return '';
    const [yyyy, mm, dd] = date.split('-');
    let horaFormatada = time.length === 5 ? `${time}:00` : time;
    return `${dd}/${mm}/${yyyy} ${horaFormatada}`;
  }

  popularResponsavelObra(): void {
    this._tarefaService.listResponsables().subscribe(
      (response) => {
        this.responsavel = response.data.sort((a, b) =>
          a.name.localeCompare(b.name),
        );
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
      },
    );
  }

  popularAcao(): void {
    this._tarefaService.listActions().subscribe(
      (response) => {
        this.tarefas = response.data.sort((a, b) =>
          a.description.localeCompare(b.description),
        );
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
      },
    );
  }

  listarObras(): void {
    this._tarefaService.listWorks().subscribe(
      (response) => {
        this.obras = response.data;
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
      },
    );
  }

  limparCampos() {
    this.description = '';
    this.data = '';
    this.hora = '';
    this.responsibleID = '';
    this.actionID = '';
    this.selectedObra = null;
    this.campoObrigatorioErro = false;
  }
}
